'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('../util');

exports.default = {
  getCard: function getCard(api, cardId, loyaltyCardAction) {
    var query = '\n      query {\n        me {\n          loyaltyCards(id:"' + cardId + '") {\n            id\n            voucher {\n              id\n              message\n              validityPeriod {\n                from\n                to\n              }\n              discount {\n                amount\n                format\n              }\n\n            }\n          }\n        }\n      }';

    var queryName = 'me:getCard';
    return (0, _util.wrapAction)(loyaltyCardAction, 'me', 'getCard', api.fetch(query, {}, queryName));
  },
  getActiveCard: function getActiveCard(api, data, loyaltyCardAction) {
    var query = 'query {\n      me {\n        id\n        activeLoyaltyCard {\n          id\n          stampThreshold\n          totalStamps\n          instance {\n            id\n            stamps {\n              timestamp\n            }\n          }\n          voucher {\n            id\n            message\n            validityPeriod {\n              from\n              to\n            }\n            discount {\n              amount\n              format\n            }\n            instance {\n              id\n              redeemed\n              redemptionDate\n              invalidated\n            }\n          }\n        }\n      }\n    }';

    var queryName = 'me:getActiveCard';
    return (0, _util.wrapAction)(loyaltyCardAction, 'me', 'getActiveCard', api.fetch(query, {}, queryName));
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/service/loyaltyCard.js
// module id = 434
// module chunks = 0